/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Transforms the create bulletin board api endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformCreateBulletinBoardApiResponse(response) {
    return Object.assign(Object.assign({}, response.meta), response.data);
}
/**
 * Transforms the create bulletin endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformCreateBulletinResponse(response) {
    return Object.assign(Object.assign({}, response.data.meta), response.data.data);
}
/**
 * Transforms the read bulletin endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadBulletinResponse(response) {
    return Object.assign(Object.assign({}, response.data.meta), response.data.data);
}
